/*
 *  Module for initializing Google Analytics
 */
rs.module("layouts/googleanalytics",

    [],

    function () {

        // Initialize the module
        function initialize(googleAnalyticsMeasurementID) {

            if (googleAnalyticsMeasurementID) {

                // Dynamically load the Google Analytics gtag library using the configured Measurement ID
                var script = document.createElement('script');
                script.src = 'https://www.googletagmanager.com/gtag/js?id=' + googleAnalyticsMeasurementID;
                document.head.appendChild(script);

                // Initialize the gtag function and configure Google Analytics with the configured Measurement ID
                var scriptBlock = document.createElement('script');
                scriptBlock.type = 'text/javascript';
                scriptBlock.text = `
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', '${googleAnalyticsMeasurementID}');
                `;
                document.head.appendChild(scriptBlock);
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);